import { Alert } from '@themenu/design-system'
import React, { lazy, Suspense, useEffect, type ReactElement } from 'react'
import { useIntl } from 'react-intl'

import { Loader } from '../components/Loader'
import { ErrorBoundary } from '../components/Shared/ErrorBoundary'
import { Layout } from '../components/Shared/Layout'
import { getAccessToken } from '../services/authentication'
import { environmentVariables } from '../utils/environmentVariables'
import { redirectToUrl } from '../utils/location'

const LazyChangePhoneNumberPage = lazy(() =>
  import('../pages/ChangePhoneNumber').then((module) => ({ default: module.ChangePhoneNumberContainer })),
)

export const ChangePhoneNumberRoute = (): ReactElement => {
  const intl = useIntl()

  useEffect(() => {
    if (!getAccessToken()) {
      redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin`)
    }
  }, [])

  if (!getAccessToken()) {
    return <Loader />
  }

  const errorFallback = (
    <Layout hideFooter>
      <div className="flex h-dvh items-center justify-center px-20">
        <Alert
          backgroundOpacity="solid"
          severity="error"
          title={intl.formatMessage({ id: 'profile.error.title' })}
          secondaryText={intl.formatMessage({ id: 'profile.error.boundary' })}
        />
      </div>
    </Layout>
  )

  return (
    <ErrorBoundary fallback={errorFallback}>
      <Suspense fallback={<Loader />}>
        <LazyChangePhoneNumberPage />
      </Suspense>
    </ErrorBoundary>
  )
}
